export default __webpack_public_path__ + "static/media/CALIDAD.f1ad94ce.jpg";